import _debounce from 'lodash/debounce'
import { AnySourceStream, Stream } from '../stream'
import { Pass } from './pass'

export class Debounce<V = any, E = any, C = any, T = V> extends Pass<V, E, C> {
    protected last: T | undefined

    constructor(
        protected source?: AnySourceStream<V, E, C>,
        protected wait?: number,
        protected options?: { leading?: boolean; trailing?: boolean; maxWait?: number }
    ) {
        super(source)
        this.debouncedValue = _debounce(this._value, wait, options)
    }

    debouncedValue = _debounce(this._value, this.wait, this.options)

    value(value: V) {
        this.debouncedValue(value)
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        debounce<T = DV>(
            wait?: number,
            options?: { leading?: boolean; trailing?: boolean; maxWait?: number }
        ): MirrorStream<DV, DE, DC>
    }
}

Stream.prototype.debounce = function <V, E, C, T = V>(
    this: AnySourceStream<V, E, C>,
    wait?: number,
    options?: { leading?: boolean; trailing?: boolean; maxWait?: number }
) {
    return new Debounce(this, wait, options) // tslint:disable-line:no-invalid-this
}
